export const ENDPOINTS = {
  LOGIN: '/api/portal-admin/login'
} as const;